import { render, staticRenderFns } from "./DevTools.vue?vue&type=template&id=9c8ab82a&scoped=true&"
import script from "./DevTools.vue?vue&type=script&lang=js&"
export * from "./DevTools.vue?vue&type=script&lang=js&"
import style0 from "./DevTools.vue?vue&type=style&index=0&id=9c8ab82a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c8ab82a",
  null
  
)

export default component.exports